// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SidebarItem_menuItem__yNRwQ {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 20px;
    border-radius: 8px;
    margin: 6px 0;
    font-size: 1.1rem;
    font-weight: 500;
    color: #1976d2;
    background: #f7faff;
    cursor: pointer;
    border: none;
    transition: background 0.2s, color 0.2s, box-shadow 0.2s;
    box-shadow: 0 1px 4px rgba(25, 118, 210, 0.04);
}
.SidebarItem_menuItem__yNRwQ:hover {
    background: #e3f0fc;
    color: #1565c0;
    box-shadow: 0 2px 8px rgba(25, 118, 210, 0.10);
}
.SidebarItem_collapsed__Mm482 .SidebarItem_menuItem__yNRwQ .SidebarItem_label__af-7h { display: none; }
.SidebarItem_collapsed__Mm482 .SidebarItem_inner__NhZ\\+O { gap: 0; }
.SidebarItem_inner__NhZ\\+O {
    display: flex;
    align-items: center;
    gap: 12px;
}
.SidebarItem_icon__OYbO8 {
    width: 20px;
    height: 20px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}
.SidebarItem_label__af-7h {
    line-height: 1.2;
}
`, "",{"version":3,"sources":["webpack://./src/Components/SidebarItem/SidebarItem.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,wDAAwD;IACxD,8CAA8C;AAClD;AACA;IACI,mBAAmB;IACnB,cAAc;IACd,8CAA8C;AAClD;AACA,uFAA8B,aAAa,EAAE;AAC7C,2DAAoB,MAAM,EAAE;AAC5B;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;AACA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,gBAAgB;AACpB","sourcesContent":[".menuItem {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 12px;\r\n    padding: 12px 20px;\r\n    border-radius: 8px;\r\n    margin: 6px 0;\r\n    font-size: 1.1rem;\r\n    font-weight: 500;\r\n    color: #1976d2;\r\n    background: #f7faff;\r\n    cursor: pointer;\r\n    border: none;\r\n    transition: background 0.2s, color 0.2s, box-shadow 0.2s;\r\n    box-shadow: 0 1px 4px rgba(25, 118, 210, 0.04);\r\n}\r\n.menuItem:hover {\r\n    background: #e3f0fc;\r\n    color: #1565c0;\r\n    box-shadow: 0 2px 8px rgba(25, 118, 210, 0.10);\r\n}\r\n.collapsed .menuItem .label { display: none; }\r\n.collapsed .inner { gap: 0; }\r\n.inner {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 12px;\r\n}\r\n.icon {\r\n    width: 20px;\r\n    height: 20px;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n.label {\r\n    line-height: 1.2;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menuItem": `SidebarItem_menuItem__yNRwQ`,
	"collapsed": `SidebarItem_collapsed__Mm482`,
	"label": `SidebarItem_label__af-7h`,
	"inner": `SidebarItem_inner__NhZ+O`,
	"icon": `SidebarItem_icon__OYbO8`
};
export default ___CSS_LOADER_EXPORT___;
